export default __webpack_public_path__ + "static/thumb-bottles-fe5ad7ca4046a25ca9db8bfd6d061954.png";